import type { Theme } from './types';

export const gradientTheme: Theme = {
  id: 'gradient',
  name: 'Gradient',
  description: 'Gradientowy header z rozowymi i fioletowymi akcentami',
  preview: {
    primary: '#faf5ff',
    secondary: '#7c3aed',
    accent: '#ec4899',
  },
  colors: {
    bgPrimary: '#faf5ff',
    bgSecondary: '#ffffff',
    bgTertiary: '#f5f3ff',
    bgAccent: '#ede9fe',

    sidebarBg: '#1e1b4b',
    sidebarText: '#c4b5fd',
    sidebarHover: '#312e81',
    sidebarActive: '#a78bfa',

    headerBg: '#7c3aed',
    headerGradient: 'linear-gradient(135deg, #7c3aed 0%, #db2777 50%, #f97316 100%)',
    headerText: '#ffffff',

    textPrimary: '#1e1b4b',
    textSecondary: '#4c1d95',
    textMuted: '#8b5cf6',
    textInverse: '#ffffff',

    borderPrimary: '#e9d5ff',
    borderSecondary: '#c4b5fd',
    borderAccent: '#a78bfa',

    accentPrimary: '#7c3aed',
    accentHover: '#6d28d9',
    accentLight: '#ede9fe',

    success: '#10b981',
    successLight: '#d1fae5',
    warning: '#f59e0b',
    warningLight: '#fef3c7',
    error: '#ef4444',
    errorLight: '#fee2e2',
    info: '#8b5cf6',
    infoLight: '#ede9fe',

    shadow: '0 4px 14px rgba(124, 58, 237, 0.15)',
    shadowLg: '0 20px 25px -5px rgba(124, 58, 237, 0.2)',
    overlay: 'rgba(30, 27, 75, 0.6)',

    scrollbarTrack: '#f5f3ff',
    scrollbarThumb: '#c4b5fd',
    scrollbarThumbHover: '#a78bfa',

    inputBg: '#ffffff',
    inputText: '#1e1b4b',
  },
  effects: {
    gradients: true,
  },
};
